import * as HLF from "html-living-framework";
import { OutlineFilter } from "Filters/OutlineFilter";
import { Button } from "GameObjects/UI/Button";
import { LayoutButton } from "GameObjects/UI/LayoutButton";
import { RestStopGame } from "States/RestStopGame";
import { StressorType } from "Data/StressorType";
import { LayoutSprite } from "GameObjects/UI/LayoutSprite";

const margin = 10;
export class PictographIcon extends LayoutSprite {
    protected _icon = this.addChild(new PIXI.Sprite());
    public setIcon(pTexture: PIXI.Texture) {
        this._icon.texture = pTexture;
        this._icon.anchor.set(0.5, 0.5);
        this._icon.width = this.texture.width - margin;
        this._icon.height = this.texture.height - margin;
        this._icon.scale.set(Math.min(this._icon.scale.x, this._icon.scale.y));
    }
}